import {opsApi} from 'services/apis'
import {SET_WALLET_ERROR, SET_WALLET_LOADED, SET_WALLET_LOADING} from 'constants/actionTypes'
import type {AppDispatch} from 'services/store'
import type {
  CreatePaymentIntentRequestBody,
  CreatePaymentIntentResponse,
  GetUserWalletResponse
} from 'types/orderTypes'
import {Stripe, StripeCardNumberElement} from '@stripe/stripe-js'

export function getWallet() {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: SET_WALLET_LOADING
    })

    return opsApi
      .get<GetUserWalletResponse>('wallet')
      .then(res => {
        dispatch({
          type: SET_WALLET_LOADED,
          payload: res
        })
      })
      .catch(err => {
        dispatch({
          type: SET_WALLET_ERROR,
          payload: err
        })
      })
  }
}

export function deleteWallet() {
  return (dispatch: AppDispatch) => {
    return opsApi
      .delete('wallet')
      .then(() => {
        dispatch({
          type: SET_WALLET_LOADED,
          payload: {}
        })
      })
      .catch(err => {
        dispatch({
          type: SET_WALLET_ERROR,
          payload: err
        })
      })
  }
}

export function saveCard(
  cardPayload: CreatePaymentIntentRequestBody,
  cardElement: StripeCardNumberElement,
  stripe: Stripe
) {
  return opsApi.post<CreatePaymentIntentResponse>('wallet', cardPayload).then(({clientSecret}) => {
    if (clientSecret) {
      const {userEmail: email, userName: name} = cardPayload
      return stripe
        .confirmCardSetup(clientSecret, {
          payment_method: {
            card: cardElement,
            billing_details: {
              email,
              name
            }
          }
        })
        .then(result => {
          if (result.error) {
            // TODO: add toast here
            throw new Error()
          }
        })
    }
  })
}
